export default () => (
  <svg version="1.1" viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-306 -11)">
      <polygon points="311 23 306 18 308 16 311 19 319 11 321 13" />
    </g>
  </svg>
);
